import { Box, Button, Container, Grid, Stack } from "@mui/material"
import ExcelJS from "exceljs"; // Excelファイル生成用ライブラリ
import { Radar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
  } from "chart.js";
import { useRecoilValue } from "recoil";
import userState from "../../recoil/atoms/userState";
import { culcGuestScores } from "../../utils/culcGuestScores";
  
  ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
  );


const GTResult = ({answers, scores} : {answers: (number|null)[], scores: number[]}) => {
    const navigate = useNavigate();
    const userData = useRecoilValue(userState); // Recoilのユーザー情報を取得

    const data = {
        labels: ['写真', '3次元映像', '言語映像', '言語抽象', '聴覚・言語', '聴覚・音'],
        datasets: [
          {
            data: [Math.min(50,scores[0]), Math.min(50,scores[1]), Math.min(50,scores[2]), Math.min(50,scores[3]), Math.min(50,scores[4]), Math.min(50,scores[5])],
            backgroundColor: 'rgba(194, 136, 109, 0.2)',
            borderColor: 'rgba(194, 136, 109, 1)',
            borderWidth: 1,
          },
        ],
      };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(tooltipItem: any) {
                        return tooltipItem.label + ': ' + (tooltipItem.raw === 50 ? '50点以上' : tooltipItem.raw +'点');
                    },
                },
            },
        },
        scales: {
            r: {
                min: 0,
                max: 50,
                ticks: {
                    stepSize: 10,
                    display:false,
                },
            },
        },
    };

    // Excelファイルのダウンロード処理
    const handlerClickDownloadButton = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
    
        const workbook = new ExcelJS.Workbook(); // Excelワークブックを作成
        workbook.addWorksheet("sheet1");
        const worksheet = workbook.getWorksheet("sheet1");
        if (!worksheet) return;
    
        worksheet.columns = [
            { header: "", key: "c1" },
            { header: "", key: "c2" },
            { header: "", key: "c3" }
        ];
    
        const tmpRows = [
            {c1: '認知特性テスト'},
            {c1: "受験者", c2: userData.email},
            {c1: "タイプ別スコア", c3: String(new Date().toLocaleDateString())},
        ];
    
        // タイプごとの結果を追記
        data.labels?.forEach((l, i) => {
            tmpRows.push({c1: l, c3: String(scores[i])});
        });
    
        worksheet.addRows(tmpRows); // 行を追加
    
        const uint8Array = await workbook.xlsx.writeBuffer();
        const blob = new Blob([uint8Array], { type: "application/octet-binary" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `【結果】認知特性テスト.xlsx`; // ファイル名を設定
        a.click();
        a.remove();
    };

    const size = Math.min(window.innerWidth * 0.9, 400);

    return (
        <Container>
            <Box>
                ■ 認知特性テスト
                <Grid container>
                    <Grid item minWidth={size} minHeight={size}>
                        <Radar data={data} options={options}/>
                    </Grid>
                    <Grid item marginLeft={2}>
                        <Stack>
                        {data.labels?.map((l,i) => {
                            if (data.datasets[0]?.data[i] > 25) {
                                return (<Box fontSize={20} marginLeft={2}>{data.labels[i]}タイプ</Box>)
                            }
                        })}
                        </Stack>
                    </Grid>
                </Grid>
                <div style={{display: 'inline-block', float: 'right'}}>
                    <Button
                        sx={{mr: 2}}
                        variant="outlined"
                        onClick={()=> {navigate('/entry/home')}}
                    >
                        Homeに戻る
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={(e)=> {handlerClickDownloadButton(e)}}
                    >
                        結果を出力
                    </Button>
                </div>
            </Box>
        </Container>
    )
}

export default GTResult;